class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartUpgradeButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.handleUpgrade.bind(this));
  }

  handleUpgrade(event) {
    event.preventDefault();
    
    const currentVariantId = this.dataset.currentVariant;
    const nextVariantId = this.dataset.nextVariant;
    const quantity = parseInt(this.dataset.quantity);
    
    if (!nextVariantId || !currentVariantId) {
      return;
    }

    this.button.classList.add('loading');
    this.button.disabled = true;
    
    const cartItem = this.closest('.cart-notification-product');
    if (cartItem) {
      cartItem.classList.add('loading');
      const loadingOverlay = cartItem.querySelector('.loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.classList.remove('hidden');
      }
    }

    let oldItemProperties = {};

    this.getCurrentCart()
      .then((cart) => {
        const oldItem = cart.items.find(item => item.variant_id == currentVariantId);
        if (oldItem && oldItem.properties) {
          oldItemProperties = oldItem.properties;
        }
        return oldItemProperties;
      })
      .then((properties) => {
        return this.addVariant(nextVariantId, quantity, properties);
      })
      .then(() => {
        return new Promise(resolve => setTimeout(resolve, 500));
      })
      .then(() => {
        return this.getCurrentCart();
      })
      .then((cart) => {
        const oldVariantLine = this.findVariantLine(cart, currentVariantId);
        
        if (oldVariantLine) {
          return this.removeOldVariant(oldVariantLine);
        } else {
          throw new Error('Could not find old variant in cart');
        }
      })
      .then((parsedState) => {
        return this.refreshCart(parsedState);
      })
      .catch((error) => {
        console.error('Upgrade failed:', error);
        alert('Failed to upgrade. Please try again.');
        this.button.classList.remove('loading');
        this.button.disabled = false;
        if (cartItem) {
          cartItem.classList.remove('loading');
          const loadingOverlay = cartItem.querySelector('.loading-overlay');
          if (loadingOverlay) {
            loadingOverlay.classList.add('hidden');
          }
        }
      });
  }

  getCurrentCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  findVariantLine(cart, variantId) {
    for (let i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id == variantId) {
        return i + 1;
      }
    }
    return null;
  }

  addVariant(variantId, quantity, properties = {}) {
    const formData = {
      items: [{
        id: parseInt(variantId),
        quantity: quantity,
        properties: properties
      }]
    };

    return fetch('/cart/add.js', {
      ...fetchConfig(),
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error('Failed to add variant to cart');
        });
      }
      return response.json();
    });
  }

  removeOldVariant(lineIndex) {
    const body = JSON.stringify({
      line: lineIndex,
      quantity: 0,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    });

    return fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: body
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error('Failed to remove old variant');
        });
      }
      return response.text();
    })
    .then(state => {
      return JSON.parse(state);
    });
  }

  refreshCart(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      
      if (renderSelector && parsedState.sections && parsedState.sections[section.id]) {
        const newHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
        renderSelector.innerHTML = newHTML;
      }
    });

    // UPDATE PROGRESS BAR WITH CART TOTAL
    setTimeout(() => {
      if (typeof freeShippingProgressBar !== 'undefined' && freeShippingProgressBar && parsedState.total_price !== undefined) {
        freeShippingProgressBar.updateProgress(parsedState.total_price);
      }
    }, 50);

    if (parsedState.sections && parsedState.sections["cart-notification-count"]) {
      let cartItemCount = parseInt(
        this.getSectionInnerHTML(parsedState.sections["cart-notification-count"])
      );

      const emptyCartItem = document.getElementById("min-cart-items");
      const cartItemMessageShow = document.querySelector(".empty__cart__item");
      const emptyCartButtonDisable = document.getElementById("empty__cart__button");
      const cartAddSuccess = document.querySelector(".item__success_message");
      const cartEmptyHead = document.querySelector(".item__empty_message");

      if (cartItemCount == 0) {
        if (emptyCartItem) emptyCartItem.classList.add("no-js-inline");
        if (emptyCartButtonDisable) emptyCartButtonDisable.classList.add("no-js-inline");
        if (cartItemMessageShow) cartItemMessageShow.classList.remove("no-js-inline");
        if (cartAddSuccess) cartAddSuccess.classList.add("no-js-inline");
        if (cartEmptyHead) cartEmptyHead.classList.remove("no-js-inline");
      } else {
        if (emptyCartItem) emptyCartItem.classList.remove("no-js-inline");
        if (emptyCartButtonDisable) emptyCartButtonDisable.classList.remove("no-js-inline");
        if (cartItemMessageShow) cartItemMessageShow.classList.add("no-js-inline");
        if (cartAddSuccess) cartAddSuccess.classList.remove("no-js-inline");
        if (cartEmptyHead) cartEmptyHead.classList.add("no-js-inline");
      }
    }

    const actionOverlay = document.querySelector(".cart_action_drawer_overlay");
    if (actionOverlay) {
      actionOverlay.classList.remove("active");
    }

    return Promise.resolve();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-subtotal' },
      { id: 'cart-notification-count' },
      { id: 'cart-notification-discount' }
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-upgrade-button', CartUpgradeButton);


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );

    this.emptyCartItem = document.getElementById("min-cart-items");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById(
      "empty__cart__button"
    );

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
      document
        .querySelector(".cart_action_drawer_overlay")
        .classList.add("active");
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      if (renderSelector) {
        renderSelector.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id]
        );
      }
    });

    let cartItemCount = parseInt(
      this.getSectionInnerHTML(parsedState.sections["cart-notification-count"])
    );

    // UPDATE PROGRESS BAR - Fetch cart data separately
    setTimeout(() => {
      if (typeof freeShippingProgressBar !== 'undefined' && freeShippingProgressBar) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            freeShippingProgressBar.updateProgress(cart.total_price);
          })
          .catch(error => console.error('Error fetching cart:', error));
      }
    }, 50);

    if (cartItemCount == 0) {
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      this.cartAddSuccess.classList.add("no-js-inline");
      this.cartEmptyHead.classList.remove("no-js-inline");
    } else {
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      this.cartAddSuccess.classList.remove("no-js-inline");
      this.cartEmptyHead.classList.add("no-js-inline");
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount"
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.remove("no-js-inline");
    } else {
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);


// Free Shipping Progress Bar Manager
class FreeShippingProgressBar {
  constructor() {
    this.goalAmount = 20000; // $200.00 in cents
    this.hasShownConfetti = false;
    this.cacheElements();
  }

  cacheElements() {
    this.progressSection = document.getElementById('cart-drawer-progress');
    this.progressMessage = document.getElementById('progress-message');
    this.amountRemaining = document.getElementById('amount-remaining');
    this.progressBarFill = document.getElementById('progress-bar-fill');
    
    return !!(this.progressSection && this.progressMessage && this.progressBarFill);
  }

  updateProgress(cartTotal) {
    const elementsExist = this.cacheElements();
    
    if (!elementsExist) {
      return;
    }

    const remaining = this.goalAmount - cartTotal;
    const progressPercent = Math.min((cartTotal / this.goalAmount) * 100, 100);

    if (this.progressBarFill) {
      this.progressBarFill.style.width = `${progressPercent}%`;
    }

    if (remaining <= 0) {
      if (this.progressMessage) {
        this.progressMessage.innerHTML = "Congratulations! You've got free shipping!";
        this.progressMessage.classList.add('success');
      }
      
      if (!this.hasShownConfetti) {
        this.triggerConfetti();
        this.hasShownConfetti = true;
      }
    } else {
      const remainingFormatted = this.formatMoney(remaining);
      if (this.progressMessage) {
        this.progressMessage.innerHTML = `You're only <span class="amount-remaining">${remainingFormatted}</span> away from free shipping!`;
        this.progressMessage.classList.remove('success');
      }
      this.hasShownConfetti = false;
    }
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  triggerConfetti() {
    const confettiContainer = document.createElement('div');
    confettiContainer.className = 'cart-confetti-container';
    document.body.appendChild(confettiContainer);

    const colors = [
      '#FF6B9D', '#C44569', '#FFA502', '#FFD32D', '#26de81',
      '#20bf6b', '#4bcffa', '#0fb9b1', '#a55eea', '#8854d0',
      '#fd79a8', '#e74c3c', '#f39c12', '#3498db', '#2ecc71',
      '#9b59b6', '#1abc9c', '#e67e22', '#f368e0', '#48dbfb'
    ];

    const shapes = ['rectangle', 'square', 'circle', 'ribbon'];

    for (let i = 0; i < 50; i++) {
      const confetti = document.createElement('div');
      confetti.className = `cart-confetti ${shapes[Math.floor(Math.random() * shapes.length)]}`;
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = `${Math.random() * 100}%`;
      
      const duration = 3.5 + Math.random() * 1;
      const delay = Math.random() * 0.3;
      const drift = (Math.random() - 0.5) * 150;
      const rotation = Math.random() * 900;
      const flip = Math.random() * 540;
      
      confetti.style.animationDuration = `${duration}s`;
      confetti.style.animationDelay = `${delay}s`;
      confetti.style.setProperty('--drift', `${drift}px`);
      confetti.style.setProperty('--rotation', `${rotation}deg`);
      confetti.style.setProperty('--flip', `${flip}deg`);
      
      confettiContainer.appendChild(confetti);
    }

    setTimeout(() => {
      confettiContainer.remove();
    }, 5000);
  }
}

// Initialize progress bar manager with error handling
let freeShippingProgressBar;
try {
  freeShippingProgressBar = new FreeShippingProgressBar();
} catch (error) {
  console.error('Failed to initialize free shipping progress bar:', error);
}


class OpenMiniCart extends HTMLElement {
  constructor() {
    super();
    
    this.cartButton =  this.querySelector('a');

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);

    setTimeout(() => {
      if (typeof freeShippingProgressBar !== 'undefined' && freeShippingProgressBar) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            freeShippingProgressBar.updateProgress(cart.total_price);
          })
          .catch(error => console.error('Error fetching cart:', error));
      }
    }, 100);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);


// Update progress bar when page loads
document.addEventListener('DOMContentLoaded', function() {
  if (typeof freeShippingProgressBar !== 'undefined' && freeShippingProgressBar) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        freeShippingProgressBar.updateProgress(cart.total_price);
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
});